import BaseService from './base.service';

export default class ExpertiseService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getListHome = query => {
        return this.get('/expertise/list', query);
    };

    getByUser = query => {
        return this.get('/expertise/by-user', query);
    };
}
